import { UserManager } from 'oidc-client-ts';

import { userManagerConfig } from '@/configs/user-manager-config';

export const userManager = new UserManager(userManagerConfig);
